import { faCircleNotch, faClose, faEye, faEyeSlash, faPlus, faQuestion, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BottomSheet from "components/reusable/BottomSheet";
import ErrorMessage from "components/reusable/ErrorMessage";
import AuthContext from "context/AuthContext";
import useToastContext from "hooks/useToastContext";
import { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { apiPost } from "utils/apiFetch";
import pathObj from "utils/apiPath";
import { validationRegex, validationRules } from "utils/constants";

function BusinessRegistration(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const {
    register,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });

  const [searchParams] = useSearchParams();
  const name = searchParams.get("name") || props.prefilledFields?.first_name;
  const surname = searchParams.get("surname") || props.prefilledFields?.last_name;
  const email = searchParams.get("email") || props.prefilledFields?.email;
  const phone = searchParams.get("phone") || props.prefilledFields?.phone;
  const nid = searchParams.get("nid") || props.prefilledFields?.nid_nipt;

  useEffect(() => {
    if (name) {
      setValue("first_name", name);
    }
    if (surname) {
      setValue("last_name", surname);
    }
    if (email) {
      setValue("email", email);
    }
    if (phone) {
      setValue("phone", phone);
    }
    if (nid) {
      setValue("NID", nid);
    }
  }, [name, surname, email, phone, nid, setValue]);

  const profilePicRef = useRef();
  const frontIDRef = useRef();
  const backIDRef = useRef();
  const businessExtractRef = useRef();
  const businessLicenseRef = useRef();

  const [icon1, setIcon1] = useState(true);
  const [icon2, setIcon2] = useState(true);
  const [loading, setLoading] = useState(false);

  const [profile_pic, setProfile_pic] = useState("");
  const [profilePicError, setProfilePicError] = useState("");

  const [identityCardFront, setIdentityCardFront] = useState("");
  const [identityCardFrontError, setIdentityCardFrontError] = useState("");

  const [identityCardBack, setIdentityCardBack] = useState("");
  const [identityCardBackError, setIdentityCardBackError] = useState("");

  const [termsAndCondition, setTermsAndCondition] = useState(false);
  const [termsAndConditionError, setTermsAndConditionError] = useState(false);

  const [showCardIDHint, setShowCardIDHint] = useState(false);

  const [businessExtract, setBusinessExtract] = useState("");
  const [businessExtractError, setBusinessExtractError] = useState(false);

  const [businessLicense, setBusinessLicense] = useState("");
  const [businessLicenseError, setBusinessLicenseError] = useState(false);

  const notification = useToastContext();
  const preventSpace = (e) => {
    e.target.value = e.target.value.trim();
  };

  const handleProfilePicChange = (e) => {
    const image = e?.target?.files[0];
    const isValidImage = validateFiles(e);
    if (isValidImage) {
      setProfile_pic(image);
      setProfilePicError("");
    } else {
      setProfile_pic("");
    }
  };
  const identityCardBackChange = (e) => {
    const image = e?.target?.files[0];
    const isValidImage = validateFiles(e);
    if (isValidImage) {
      setIdentityCardBack(image);
      setIdentityCardBackError("");
    } else {
      setIdentityCardBack("");
    }
  };
  const validateFiles = (e) => {
    const getType = e.target.files[0].type.split("/");
    const fileSize = (e.target.files[0]?.size / (1024 * 1024)).toFixed(2);
    if (getType[1] !== undefined && (getType[1] === "jpeg" || getType[1] === "png" || getType[1] === "jpg")) {
      if (fileSize > 3) {
        notification.error("Please select image below 3 MB");
        return false;
      }
      return true;
    } else {
      notification.error("Only jpeg,png,jpg formats are allowed");
    }
  };
  const identityCardFrontChange = (e) => {
    const image = e?.target?.files[0];
    const isValidImage = validateFiles(e);
    if (isValidImage) {
      setIdentityCardFront(image);
      setIdentityCardFrontError("");
    } else {
      setIdentityCardFront("");
    }
  };

  const businessExtractChange = (e) => {
    const image = e?.target?.files[0];
    const isValidImage = validateFiles(e);
    if (isValidImage) {
      setBusinessExtract(image);
      setBusinessExtractError("");
    } else {
      setBusinessExtract("");
    }
  };

  const businessLicenseChange = (e) => {
    const image = e?.target?.files[0];
    const isValidImage = validateFiles(e);
    if (isValidImage) {
      setBusinessLicense(image);
      setBusinessLicenseError("");
    } else {
      setBusinessLicense("");
    }
  };

  const checkValidation = () => {
    let isValid = true;
    if (profile_pic === "") {
      setProfilePicError(t("PLEASE_UPLOAD_PROFILE_PICTURE"));
      isValid = false;
    }
    if (identityCardFront === "") {
      setIdentityCardFrontError(t("PLEASE_UPLOAD_IDENTITY_CARD_FRONT"));
      isValid = false;
    }
    if (identityCardBack === "") {
      setIdentityCardBackError(t("PLEASE_UPLOAD_IDENTITY_CARD_BACK"));
      isValid = false;
    }
    if (businessExtract === "") {
      setBusinessExtractError(t("PLEASE_UPLOAD_BUSINESS_EXTRACT"));
      isValid = false;
    }
    if (businessLicense === "") {
      setBusinessLicenseError(t("PLEASE_UPLOAD_BUSINESS_LICENSE"));
      isValid = false;
    }

    return isValid;
  };
  const onSubmit = async (data) => {
    try {
      const isValid = checkValidation();
      if (!isValid) return;
      if (!termsAndCondition) {
        setTermsAndConditionError(true);

        return;
      }

      setLoading(true);
      const formData = new FormData();
      formData.append("first_name", data?.first_name);
      formData.append("last_name", data?.last_name);
      formData.append("businessName", data?.businessName);
      formData.append("password", data.password);
      formData.append("confirm_password", data.password);
      formData.append("phone", data.phone);
      formData.append("email", data.email);
      formData.append("username", data.username);
      formData.append("profile_pic", profile_pic);
      formData.append("niptNo", data.NID);
      formData.append("cardIdNo", data.cardIdNo);
      formData.append("administratorNid", data.administratorNid);
      formData.append("NID", data.NID);
      formData.append("userType", "business");
      formData.append("identityCardFront", identityCardFront);
      formData.append("identityCardBack", identityCardBack);
      formData.append("businessExtract", businessExtract);
      formData.append("businessLicense", businessLicense);

      formData.append("referral", data.referral);
      formData.append("country_code", "355");
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const res = await apiPost(pathObj.signupUser, formData, config);
      if (res.data.success === true) {
        notification.success(res.data.message);
        reset();
        navigate("/register/otp", {
          state: {
            username: data.username,
            email: data.email,
            phone: data.phone,
            country_code: "355",
          },
        });
      } else {
        window.scrollTo(0, 0);
        notification.error(res?.data?.message);
      }
    } catch (error) {}
    setLoading(false);
  };

  useEffect(() => {
    if (user !== null) {
      navigate("/dashboard");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <form
      onSubmit={handleSubmit(onSubmit, () => {
        checkValidation();
      })}
      className="register-form-sec"
    >
      <div className="container mx-auto">
        <div className="flex flex-col items-center">
          <input type="file" className="hidden" ref={profilePicRef} accept="image/png, image/jpg, image/jpeg" onChange={handleProfilePicChange} />
          <div className="relative">
            <img
              src={profile_pic !== "" ? URL.createObjectURL(profile_pic) : "images/promo.jpg"}
              onClick={() => profilePicRef?.current?.click()}
              className="w-[10rem] h-[10rem]  rounded-2xl cursor-pointer"
              style={{ objectFit: "cover" }}
              alt=""
            />
            <FontAwesomeIcon
              icon={faPlus}
              onClick={() => profilePicRef?.current?.click()}
              className="cursor-pointer text-white bg-primary p-2 rounded-full absolute bottom-[-0.5rem] right-[-0.5rem]"
            />
          </div>
          {profilePicError && <ErrorMessage message={profilePicError} />}

          <div className="grid grid-cols-2 gap-2 mt-5 w-[90%] md:w-[25rem]">
            <div className="col-span-2 md:col-span-1">
              <input
                type="text"
                id="first_name"
                className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                placeholder={t("O_FIRST_NAME")}
                disabled={props.prefilledFields?.first_name ? true : false}
                onKeyDown={(e) => preventSpace(e)}
                {...register("first_name", {
                  required: t("REGISTER_FIRST_NAME"),
                  minLength: {
                    value: 2,
                    message: t("REGISTER_MIN_LENGTH"),
                  },
                  validate: (value) => {
                    return !!value.trim() ? true : t("REGISTER_WHITE_SPACE");
                  },
                })}
                required
              />
              <ErrorMessage message={errors?.first_name?.message} />
            </div>
            <div className="col-span-2 md:col-span-1">
              <input
                type="text"
                id="last_name"
                disabled={props.prefilledFields?.last_name ? true : false}
                className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                placeholder={t("O_LAST_NAME")}
                onKeyDown={(e) => preventSpace(e)}
                {...register("last_name", {
                  required: t("REGISTER_LAST_NAME"),
                  minLength: {
                    value: 2,
                    message: t("REGISTER_MIN_LENGTH"),
                  },
                  validate: (value) => {
                    return !!value.trim() ? true : t("REGISTER_WHITE_SPACE");
                  },
                })}
                required
              />
              <ErrorMessage message={errors?.last_name?.message} />
            </div>

            <div className="col-span-2">
              <input
                type="text"
                id="businessName"
                className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                placeholder={t("BUSINESS_NAME")}
                onKeyDown={(e) => preventSpace(e)}
                {...register("businessName", {
                  required: t("REGISTER_BUSINESS_NAME"),
                  minLength: {
                    value: 2,
                    message: t("REGISTER_MIN_LENGTH"),
                  },
                  validate: (value) => {
                    return !!value.trim() ? true : t("REGISTER_WHITE_SPACE");
                  },
                })}
                required
              />
              <ErrorMessage message={errors?.last_name?.message} />
            </div>

            <div className="col-span-2">
              <input
                type="text"
                id="NID"
                maxLength={10}
                className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                placeholder={t("REGISTER_NIPT_NO")}
                disabled={props.prefilledFields?.nid_nipt ? true : false}
                onKeyDown={(e) => preventSpace(e)}
                {...register("NID", {
                  required: t("REGISTER_NIPT_NO"),
                })}
                required
              />
              <ErrorMessage message={errors?.NID?.message} />
            </div>

            <div className="col-span-2 flex gap-2">
              <div className="w-[6rem]">
                <input
                  type="text"
                  id="country_code"
                  className="text-gray-600 disabled inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                  placeholder={t("O_LAST_NAME")}
                  disabled
                  value={props.prefilledFields?.country_code ? "+" + props.prefilledFields.country_code : "+355"}
                  onKeyDown={(e) => preventSpace(e)}
                  required
                />
              </div>
              <div className="w-full">
                <input
                  type="number"
                  id="mobile"
                  inputType="numeric"
                  maxLength={9}
                  disabled={props.prefilledFields?.phone ? true : false}
                  className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                  placeholder={t("O_MOBILE_NUMBER")}
                  onKeyDown={(e) => preventSpace(e)}
                  {...register("phone", {
                    required: t("REGISTER_MOBILE"),
                    min: {
                      value: 0,
                      message: t("REGISTER_MIN_VALUE"),
                    },
                    minLength: {
                      value: 9,
                      message: t("REGISTER_MIN_LENGTH_MOBILE"),
                    },
                  })}
                  required
                />
                <ErrorMessage message={errors?.phone?.message} />
              </div>
            </div>
            <div className="col-span-2">
              <input
                type="text"
                id="email"
                disabled={props.prefilledFields?.email ? true : false}
                className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                placeholder={t("O_EMAIL")}
                onKeyDown={(e) => preventSpace(e)}
                {...register("email", {
                  required: t("REGISTER_EMAIL"),
                  pattern: {
                    value: validationRegex.email,
                    message: t("REGISTER_EMAIL_EX"),
                  },
                })}
                required
              />
              <ErrorMessage message={errors?.email?.message} />
            </div>
            <div className="col-span-2">
              <input
                type="text"
                id="username"
                maxLength={50}
                className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                placeholder={t("O_USERNAME")}
                onKeyDown={(e) => preventSpace(e)}
                {...register("username", {
                  required: t("REGISTER_USERNAME"),
                  pattern: {
                    value: validationRegex.username,
                    message: t("REGISTER_USERNAME_EX"),
                  },
                })}
                required
              />
              <ErrorMessage message={errors?.username?.message} />
            </div>

            <div className="col-span-2">
              <h4 className="font-medium mx-2">{t("ADMINISTRATOR_IDENTITY_CARD")}</h4>
            </div>

            <div className="col-span-1">
              <div className="inputform h-[5rem] p-4 w-full flex justify-between items-center cursor-pointer" onClick={() => frontIDRef?.current?.click()}>
                <span className="font-medium">{t("FRONT")}</span>
                <input ref={frontIDRef} type="file" className="hidden" accept="image/png, image/jpg, image/jpeg" onChange={identityCardFrontChange} />
                <FontAwesomeIcon icon={faUpload} size={"xl"} />
              </div>
              {typeof identityCardFront === "object" && (
                <div
                  className="upload_card relative"
                  onClick={() => {
                    setIdentityCardFront("");
                  }}
                >
                  <img className="rounded-lg my-4 w-full h-[7rem] cursor-pointer" style={{ objectFit: "cover" }} src={URL.createObjectURL(identityCardFront)} alt="" />
                  <FontAwesomeIcon
                    icon={faClose}
                    className="touch-none cursor-pointer text-white bg-red-500 p-2 rounded-full absolute top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2"
                  />
                </div>
              )}
              {identityCardFrontError && <ErrorMessage message={identityCardFrontError} />}
            </div>

            <div className="col-span-1">
              <div className="inputform h-[5rem] p-4 w-full flex justify-between items-center cursor-pointer" onClick={() => backIDRef?.current?.click()}>
                <span className="font-medium">{t("BACK")}</span>
                <input ref={backIDRef} type="file" className="hidden" accept="image/png, image/jpg, image/jpeg" onChange={identityCardBackChange} />
                <FontAwesomeIcon icon={faUpload} size={"xl"} />
              </div>
              {typeof identityCardBack === "object" && (
                <div
                  className="upload_card relative"
                  onClick={() => {
                    setIdentityCardBack("");
                  }}
                >
                  <img className="rounded-lg my-4 w-full h-[7rem] cursor-pointer" style={{ objectFit: "cover" }} src={URL.createObjectURL(identityCardBack)} alt="" />
                  <FontAwesomeIcon
                    icon={faClose}
                    className="touch-none cursor-pointer text-white bg-red-500 p-2 rounded-full absolute top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2"
                  />
                </div>
              )}
              {identityCardBackError && <ErrorMessage message={identityCardBackError} />}
            </div>

            <div className="col-span-2">
              <input
                type="text"
                id="administratorNid"
                maxLength={10}
                className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                placeholder={t("ENTER_ADMINISTARTOR_NID")}
                disabled={props.prefilledFields?.nid_nipt ? true : false}
                onKeyDown={(e) => preventSpace(e)}
                {...register("administratorNid", {
                  required: t("ENTER_ADMINISTARTOR_NID"),
                })}
                required
              />
              <ErrorMessage message={errors?.administratorNid?.message} />
            </div>

            <div className="col-span-2 relative">
              <input
                type="text"
                id="cardIdNo"
                maxLength={9}
                className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                placeholder={t("ENTER_CARD_ID_NO")}
                disabled={props.prefilledFields?.nid_nipt ? true : false}
                onKeyDown={(e) => preventSpace(e)}
                {...register("cardIdNo", {
                  required: t("ENTER_CARD_ID_NO"),
                })}
                required
              />
              <FontAwesomeIcon
                icon={faQuestion}
                onClick={() => {
                  setShowCardIDHint(true);
                }}
                className="cursor-pointer cursor-pointer p-2 rounded-full absolute top-[0.6rem] right-[0.5rem]"
              />
              <ErrorMessage message={errors?.cardIdNo?.message} />

              {showCardIDHint && (
                <BottomSheet
                  title={t("Info")}
                  open={showCardIDHint}
                  onClose={() => {
                    setShowCardIDHint(false);
                  }}
                >
                  <img src="images/card_id_nr_example.png" className="rounded-lg" alt="" />
                </BottomSheet>
              )}
            </div>

            <div className="col-span-2">
              <h4 className="font-medium mx-2">{t("UPLOAD_BUSINESS_EXTRACT_AND_IDENTITY_CARD")}</h4>
            </div>

            <div className="col-span-2">
              <div className="inputform h-[5rem] p-4 w-full flex justify-between items-center cursor-pointer" onClick={() => businessExtractRef?.current?.click()}>
                <span className="font-medium">{t("BUSINESS_EXTRACT")}</span>
                <input ref={businessExtractRef} type="file" className="hidden" accept="image/png, image/jpg, image/jpeg" onChange={businessExtractChange} />
                <FontAwesomeIcon icon={faUpload} size={"xl"} />
              </div>
              {typeof businessExtract === "object" && (
                <div
                  className="upload_card relative"
                  onClick={() => {
                    setBusinessExtract("");
                  }}
                >
                  <img className="rounded-lg my-4 w-full h-[7rem] cursor-pointer" style={{ objectFit: "cover" }} src={URL.createObjectURL(businessExtract)} alt="" />
                  <FontAwesomeIcon
                    icon={faClose}
                    className="touch-none cursor-pointer text-white bg-red-500 p-2 rounded-full absolute top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2"
                  />
                </div>
              )}
              {businessExtractError && <ErrorMessage message={businessExtractError} />}
            </div>

            <div className="col-span-2">
              <div className="inputform h-[5rem] p-4 w-full flex justify-between items-center cursor-pointer" onClick={() => businessLicenseRef?.current?.click()}>
                <span className="font-medium">{t("BUSINESS_LICENSE")}</span>
                <input ref={businessLicenseRef} type="file" className="hidden" accept="image/png, image/jpg, image/jpeg" onChange={businessLicenseChange} />
                <FontAwesomeIcon icon={faUpload} size={"xl"} />
              </div>
              {typeof businessLicense === "object" && (
                <div
                  className="upload_card relative"
                  onClick={() => {
                    setBusinessLicense("");
                  }}
                >
                  <img className="rounded-lg my-4 w-full h-[7rem] cursor-pointer" style={{ objectFit: "cover" }} src={URL.createObjectURL(businessLicense)} alt="" />
                  <FontAwesomeIcon
                    icon={faClose}
                    className="touch-none cursor-pointer text-white bg-red-500 p-2 rounded-full absolute top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2"
                  />
                </div>
              )}
              {businessLicenseError && <ErrorMessage message={businessLicenseError} />}
            </div>

            <div className="col-span-2 relative">
              <input
                type={icon1 ? "password" : "text"}
                id="password"
                maxLength={10}
                className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                placeholder={t("O_PASSWORD")}
                onKeyDown={(e) => preventSpace(e)}
                {...register("password", {
                  required: t("REGISTER_PASSWORD"),
                  pattern: {
                    value: validationRules.password,
                    message: validationRules.passwordMessage,
                  },
                })}
                required
              />
              {icon1 ? (
                <span className="password_view cursor-pointer absolute top-[0.8rem] right-[1rem]" onClick={() => setIcon1(!icon1)}>
                  <FontAwesomeIcon icon={faEye} />
                </span>
              ) : (
                <span className="password_view cursor-pointer absolute top-[0.8rem] right-[1rem]" onClick={() => setIcon1(!icon1)}>
                  <FontAwesomeIcon icon={faEyeSlash} />
                </span>
              )}
              <ErrorMessage message={errors?.password?.message} />
            </div>

            <div className="col-span-2 relative">
              <input
                type={icon2 ? "password" : "text"}
                id="confirm_password"
                maxLength={10}
                className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                placeholder={t("OTP_CONFIRM_PASSWORD")}
                onKeyDown={(e) => preventSpace(e)}
                {...register("confirm_password", {
                  required: t("REGISTER_PASSWORD"),
                  pattern: {
                    value: validationRules.password,
                    message: validationRules.passwordMessage,
                  },
                })}
                required
              />
              {icon2 ? (
                <span className="password_view cursor-pointer absolute top-[0.8rem] right-[1rem]" onClick={() => setIcon2(!icon2)}>
                  <FontAwesomeIcon icon={faEye} />
                </span>
              ) : (
                <span className="password_view cursor-pointer absolute top-[0.8rem] right-[1rem]" onClick={() => setIcon2(!icon2)}>
                  <FontAwesomeIcon icon={faEyeSlash} />
                </span>
              )}
              <ErrorMessage message={errors?.confirm_password?.message} />
            </div>

            <div className="col-span-2">
              <input
                type="text"
                id="referral"
                maxLength={30}
                className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                placeholder={t("REGISTER_REFERRAL_CODE")}
                disabled={props.prefilledFields?.nid_nipt ? true : false}
                onKeyDown={(e) => preventSpace(e)}
                {...register("referral", {
                  pattern: {
                    value: validationRules.removeWhitespace,
                    message: "Invalid referral code.",
                  },
                })}
              />
              <ErrorMessage message={errors?.referral?.message} />
            </div>

            <div className="col-span-2">
              <div className="flex gap-2 mx-2">
                <input
                  type="checkbox"
                  checked={termsAndCondition}
                  onChange={(e) => {
                    setTermsAndCondition(e.target.checked);
                    if (e.target.checked) {
                      setTermsAndConditionError(false);
                    }
                  }}
                />
                <div className="font-medium">
                  {t("BY_SIGNING_UP_YOU_ARE_AGREEING_TO_OUR")}{" "}
                  <Link className="text-primary font-medium" to="/terms-and-conditions">
                    {t("TERMS_OF_USE")}
                  </Link>{" "}
                  {t("REGISTER_AND")}{" "}
                  <Link className="text-primary font-medium" to="/privacy-policy">
                    {t("REGISTER_PRIVACY_POLICY")}
                  </Link>
                  {termsAndConditionError && (
                    <div>
                      <ErrorMessage message={t("YOU_MUST_ACCEPT_OUR_TERMS_AND_CONDITIONS")} />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-span-2 pb-4">
              <div className="w-full mt-5">
                {loading ? (
                  <div className="btn btn_theme w-full flex items-center justify-center p-3">
                    <FontAwesomeIcon icon={faCircleNotch} className="text-white text-xl animate-spin" />
                  </div>
                ) : (
                  <button className="btn btn_theme w-full text-white" type="submit">
                    {t("O_REGISTER_TAB")}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default BusinessRegistration;
